import {useSelector} from 'react-redux'
import {AppRootState} from '../model/config'

const useProfileOpen = () => {
  const open = useSelector((state: AppRootState) => state.app.myProfileOpen)

  return [open]
}

export default useProfileOpen
